import * as React from 'react';

function SvgUpOpen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.96 13.91" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.31 13.2a2.23 2.23 0 01-3.26 0L12 5.54 3.91 13.2a2.21 2.21 0 01-3.25 0 2.39 2.39 0 010-3.3c.83-.86 9.69-9.21 9.69-9.21a2.27 2.27 0 013.26 0s8.85 8.35 9.7 9.21a2.41 2.41 0 010 3.3z" />
    </svg>
  );
}

const MemoSvgUpOpen = React.memo(SvgUpOpen);
export default MemoSvgUpOpen;
